<template>
    <div id="cesiumContainer"></div>
</template>
<script>
import * as Cesium from "cesium/Cesium";
import widgets from "cesium/Widgets/widgets.css";
import util from "../../components/util"
export default {
    data () {
        return {

        }
    },
    mounted () {
     this.init()
    },
    methods : {
      init () {
                  let viewer = util.getViewer("cesiumContainer",{
                      infoBox: true,
                      selectionIndicator: true,
                  });
                let promise = Cesium.GeoJsonDataSource.load('/demo/static/data/geojson/bj-railway.geojson');
                 promise.then(function (dataSource) {
                    viewer.dataSources.add(dataSource);
                    let entities = dataSource.entities.values;
                    for (let i = 0; i < entities.length; i++) {
                        let entity = entities[i];
                        entity.polyline.width = 25;
                        entity.polyline.material = new Cesium.PolylineGlowMaterialProperty({
                            glowPower : 0.1,
                            color: Cesium.Color.ORANGERED.withAlpha(.9)
                        });
                        // entity.polyline.material = Cesium.Color.BLUE;
                    }
                    viewer.zoomTo(entities);
                }).otherwise(function (error) {
                     window.alert(error);
                 });
          // var redTube = viewer.entities.add({
          //     name : 'Red tube with rounded corners',
          //     polylineVolume : {
          //         positions : Cesium.Cartesian3.fromDegreesArray([-85.0, 32.0,-85.0, 36.0,-89.0, 36.0]),
          //         shape : computeCircle(6000.0),
          //         //颜色回调
          //         material : new Cesium.ColorMaterialProperty(new Cesium.CallbackProperty(function() {
          //             return Cesium.Color.fromRandom({
          //                 minimumRed : 0.75,
          //                 minimumGreen : 0.75,
          //                 minimumBlue : 0.75,
          //                 alpha : 1.0
          //             });
          //         }, false))
          //     }
          // });
          // viewer.zoomTo(redTube)
          // function computeCircle(radius) {
          //     var positions = [];
          //     for (var i = 0; i < 360; i++) {
          //         var radians = Cesium.Math.toRadians(i);
          //         positions.push(new Cesium.Cartesian2(radius * Math.cos(radians), radius * Math.sin(radians)));
          //     }
          //     return positions;
          // }

         }
    }
}
</script>
<style scoped>
  #cesiumContainer {
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        overflow: hidden;
    }
</style>
